import { USE_API_MOCKS } from 'src/env';
import { RESTClientMock, RESTClient } from './client';

import { API_URL } from './apiDictionary';
import {
  QCTaskExecutionsExportResult,
} from '@dynamika-shared/types/qcTaskExecutions';
import { WorkflowExecution } from '@dynamika-shared/types/executions';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

/**
 * Every execution recorded for a task — the source of the viewer's Processes
 * history and of the QCT workstation-sync status.
 *
 * This used to be read through `@api/DXAReadings.getSyncWorkstationReadingsStatus`,
 * which is a DXA module reached by a non-DXA feature. The endpoint is generic,
 * so it belongs here.
 */
export const fetchTaskExecutions = async (clinicalTrialId: string, taskId: string) => {
  const response = await api.get<WorkflowExecution[]>(
    API_URL.qcTaskExecutions.replace(':taskId', taskId),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );

  return response.data;
};

export const fetchQCTaskExecutionsExportResult = async (
  clinicalTrialId: string,
  taskId: string,
  taskExecutionInstanceId: string
) => {
  return api.get<QCTaskExecutionsExportResult>(
    API_URL.qcTaskExecutionsExportResult
      .replace(':taskId', taskId).replace(':taskExecutionInstanceId', taskExecutionInstanceId),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      id: 'get-qc-task-executions-export-result',
    }
  );
};
